import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SelectReportType.css';
import { getReportFormatInfo } from '../GenerateReportWizardUtils';
import './SelectReportFormat.css';
import { ReportFormat, ReportType } from '../../../../Utils/Constants';

class SelectReportFormat extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    reportType: PropTypes.string,
    reportFormatType: PropTypes.string,
    setReportFormatType: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { reportType, setReportFormatType } = this.props;
    if (
      reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ||
      reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT
    ) {
      setReportFormatType(ReportFormat.XLSX);
    }
  }

  render() {
    const { t } = this.context;
    const reportFormatTypes = [ReportFormat.XLSX, ReportFormat.CSV];
    const { setReportFormatType, navigateToReportTypeRow, navigateToFilterRecordsRow } = this.props;
    const buildReportFormatCards = reportFormatTypes.map(reportFormat => (
      <ReportFormatType
        key={reportFormat}
        reportFormat={reportFormat}
        {...getReportFormatInfo(reportFormat)}
        selectedReportFormatType={this.props.reportFormatType}
        onClick={() => setReportFormatType(reportFormat)}
      />
    ));
    return (
      <div>
        {navigateToReportTypeRow}
        {navigateToFilterRecordsRow}
        <div className="reportFormatLayout">
          {t('generateReport.wizard.selectFileType')}
          <div className="reportFormatOptions">{buildReportFormatCards}</div>
        </div>
      </div>
    );
  }
}

export const ReportFormatType = ({ reportFormat, title, selectedReportFormatType, onClick }) => {
  return (
    <div className={`reportFormat ${selectedReportFormatType === reportFormat}`} onClick={onClick}>
      <div className="reportFormatType">
        <div className="content">
          <div className={`icon ${reportFormat}`} />
          <div className="name">{title}</div>
        </div>
      </div>
    </div>
  );
};
ReportFormatType.propTypes = {
  reportFormat: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  selectedReportFormatType: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default SelectReportFormat;



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/Wizard/Steps/SelectReportFormat.js